import { render, staticRenderFns } from "./AfterCaution.vue?vue&type=template&id=1867aec8&scoped=true"
import script from "./AfterCaution.vue?vue&type=script&lang=js"
export * from "./AfterCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1867aec8",
  null
  
)

export default component.exports